import request from "../shared/http";

class IntegrationsService {
  static async listProviders() {
    const { data } = await request.get("/integrations/providers");
    return data;
  }

  static async listConnected() {
    const { data } = await request.get("/integrations");
    return data;
  }

  static async startMetaOAuth() {
    const { data } = await request.post("/integrations/meta/oauth/start");
    return data;
  }

  static async startGoogleOAuth() {
    const { data } = await request.post("/integrations/google/oauth/start");
    return data;
  }

  static async startSearchConsoleOAuth() {
    const { data } = await request.post("/integrations/search_console/oauth/start");
    return data;
  }

  static async startGoogleAdsOAuth() {
    const { data } = await request.post("/integrations/google_ads/oauth/start");
    return data;
  }

  static async startLinkedInOAuth() {
    const { data } = await request.post("/integrations/linkedin/oauth/start");
    return data;
  }

  static async startTikTokOAuth() {
    const { data } = await request.post("/integrations/tiktok/oauth/start");
    return data;
  }

  static async disconnect(id) {
    const { data } = await request.delete(`/integrations/${id}`);
    return data;
  }

  static async updateSchedule(id, syncInterval) {
    const { data } = await request.put(`/integrations/${id}/schedule`, { syncInterval });
    return data;
  }

  static async getSyncLogs(limit = 20) {
    const { data } = await request.get("/sync/logs", { params: { limit } });
    return data;
  }
}

export default IntegrationsService;
